import fr_FR from './fr-FR.json'

export { fr_FR }
